import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Template.js";

/**
    * class HSN.Template.Checkout.PayPalInContext
    *
    * Encapsulates the common functionality of the PayPalInContext Template.
    **/
HSN.Template.Checkout.PayPalInContext = function () {
    var application;
    var container;
    var payPalMerchantId;
    var payPalEnvironment;
    var payPalButtonIdList;
    var payPalButtonClassList;
    var returnUrl;
    var cancelUrlOverride;
    var express;
    var commerceService;
    var deviceInformation;
    var paypalAttempts = 0;
    var maxPaypalAttempts = 5;
    /**
        * new HSN.Template.Checkout.PayPalInContext.init(config)
        * - config (Object): A configuration object for the [[HSN.Template.Checkout.PayPalInContext]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        payPalMerchantId = config.payPalMerchantId;
        payPalEnvironment = config.payPalEnvironment;
        payPalButtonIdList = config.payPalButtonIdList || [];
        payPalButtonClassList = config.payPalButtonClassList || [];
        returnUrl = config.returnUrl || '';
        cancelUrlOverride = config.cancelUrlOverride || '';
        express = config.express || false;

        commerceService = application._getCommerceService();
        deviceInformation = application.DeviceInformation;
            
        configurePayPalInContext();
    }

    function configurePayPalInContext() {
        if (typeof window.paypal !== 'undefined' && window.paypal !== null) {
            window.paypal.checkout.setup(payPalMerchantId, {
                environment: payPalEnvironment,
                click: function (event) {
                    event.preventDefault();
                    commerceService.UpdateBagPaymentProvider({ provider: "Hsn" });

                    window.paypal.checkout.initXO();
                    $.support.cors = true;
                    $.ajax({
                        url: "/payment-management/paypal-incontext/initiate",
                        type: "GET",
                        data: { "returnUrl": returnUrl, 'express' : express, "cancelUrlOverride": cancelUrlOverride},
                        async: true,
                        crossDomain: true,

                        //Load the minibrowser with the redirection url in the success handler
                        success: function (data) {
                            HSN.DataLayer.helpers.checkout(data.dataLayerUdo);
                            if (data.success) {
                                //Loading Mini browser with redirect url, true for async AJAX calls
                                window.paypal.checkout.startFlow(data.PostUrl);
                            }
                            else {
                                window.paypal.checkout.closeFlow();
                                window.location.href = data.RedirectUrl;
                            }
                        },
                        error: function (responseData, textStatus, errorThrown) {
                            alert("Error in ajax post " + responseData.statusText);
                            //Gracefully Close the minibrowser in case of AJAX errors
                            window.paypal.checkout.closeFlow();
                        }
                    });
                        
                    HSN.DataLayer.helpers.elementInteraction(null, "Modal", "PayPal");
                },
                button: buildButtonIds()
            });
        }
        else if (paypalAttempts < maxPaypalAttempts) {
            paypalAttempts++;
            setTimeout(configurePaypalInContext, 500);
        }
    }

    function buildButtonIds() {
        var result = [];

        if (payPalButtonIdList.length > 0) {
            for(var i = 0; i < payPalButtonIdList.length; i++) {
                result.push(payPalButtonIdList[i]);
            }
        }          
        if(payPalButtonClassList.length > 0) {
            for(var j = 0; j < payPalButtonClassList.length; j++) {
                var buttons = $('.' + payPalButtonClassList[j]);

                for(var k = 0; k < buttons.length; k++) {
                    result.push(buttons[k].id);
                }
            }
        }
        if(result.length === 0) {
            console.log('Error: No paypal button bindings defined');
        }

        return result;
    }

    function removePaypalIncontextScripts(clientUrl) {
        var scriptList = document.getElementsByTagName('script');

        for (var i = 0; i < scriptList.length; i++) {
            var singleScript = scriptList[i];

            if (singleScript.src.indexOf(clientUrl) > -1) {
                var parentOfScript = singleScript.parentElement;
                parentOfScript.removeChild(singleScript);
            }
        }
    }

    function removePaypalIncontextFrames() {
        var frameList = document.getElementsByTagName('iframe');

        for (var j = 0; j < frameList.length; j++) {
            var singleFrame = frameList[j];

            if (singleFrame.src.indexOf('paypal.com') > -1 && singleFrame.name.indexOf('prefetch') > -1) {
                var parentOfFrame = singleFrame.parentElement;
                parentOfFrame.removeChild(singleFrame);
            }
        }
    }

    function removePaypalPostRobotWindowEntry() {
        //paypal's js library puts this property in the window object. if you reload their js library due to an ajax refresh of the button component it will error if
        //the postRobot property is still present in the window object
        delete window["__postRobot__"];
    }

    function removePaypalInContextPiecesBeforeReload(clientUrl) {
        removePaypalIncontextScripts(clientUrl);
        removePaypalIncontextFrames();
        removePaypalPostRobotWindowEntry();
    }

    return {
        init: init,
        removePaypalInContextPiecesBeforeReload: removePaypalInContextPiecesBeforeReload
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Template/Checkout/PayPalInContext.js